import $ from 'jquery'
const ledController = {}
export default ledController.install = function(Vue, options) {
    Vue.prototype.$animateLEDS = (style, color) => {
        
        if (!Vue.prototype.$isBooth) {
            return
        }
        
        let cor = hexToRgb(color)
        let method = style + "_" + cor.r + "_" + cor.g + "_" + cor.b
        //console.log("LEDS: "+method)
        $.ajax({
            type: "POST",
            url: "https://api.spark.io/v1/devices/"+process.env.VUE_APP_PARTICLE_DEVICE_ID+"/led",
            data: {
                access_token: process.env.VUE_APP_PARTICLE_TOKEN,
                args: method
            },
            success: function(event) { 
                //console.log("LED Updated")
                // console.log(event)
                },
            error: function(error) {
                console.log("ERROR: "+error.responseText)
            },
            dataType: "json"
        })
    }
    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    function componentToHex (c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
    function rgbToHex(r, g, b) {
        return "#" + this.$componentToHex(r) + this.$componentToHex(g) + this.$componentToHex(b);
    }
}